export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Валюта"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Создать отчет\t"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Валюта результата"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Скачать"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Лист"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Допустимый формат файлов - xlsx"])}
}